import { CommonModule as NgCommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { FooterModule } from "@obg/core.footer";
import { MatCoreModule } from "@obg/mat.ui.core";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { RouterModule } from "@obg/ngx.router";
import { CommonUiModule } from "@obg/ngx.ui.common";
import { ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";
import { GlobalUiScrollbarModule } from "@obg/ngx.ui.global.scrollbar";
import { NgScrollbarModule } from "ngx-scrollbar";

import { HeaderModule } from "../../core/header/header.module";
import { SidenavModule } from "../../core/sidenav/sidenav.module";

import { CommonLayoutContainer } from "./common-layout.container";

const DIRECTIVES: any[] = [CommonLayoutContainer];

@NgModule({
	imports: [
		NgCommonModule,
		CoreModule,
		CoreContentModule,
		CoreUiModule,
		RouterModule,
		MatCoreModule,
		SidenavModule,
		GlobalUiScrollbarModule,
		NgScrollbarModule,
		HeaderModule,
		CommonUiModule,
		FooterModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class CommonLayoutModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...DIRECTIVES);
	}
}
